const fonts = {
  primary: "'HK Grotesk', 'Helvetica Neue', Helvetica, Arial, sans-serif",
}

export default fonts
